import React from 'react';

class InputButton extends React.Component {
  constructor(props) {
    super(props);
    this.button = null;
    this.activeThemeColor = props.activeThemeColor || '#000';
  }

  setDisabled = (disabled) => {
    if (this.button) {
      this.button.attributes.disabled = disabled;
    }
  }

  render() {
    let buttonJSON = this.props.buttonAttr;
    let btnstyle = '';

    buttonJSON = Object.assign({}, {
      ariaLabel: buttonJSON.label,
      ariaHidden: buttonJSON.ariaHidden || false,
    }, buttonJSON);

    if (!buttonJSON.onClickHandler) {
      buttonJSON.onClickHandler = () => true;
    }

    if (buttonJSON.style) {
      btnstyle = buttonJSON.style;
    }

    if (buttonJSON.classname) {
      btnstyle = btnstyle + ' ' + buttonJSON.classname;
    }
    
    let themeColor = {};
    if (buttonJSON?.activeCategory) {
       themeColor.backgroundColor= buttonJSON?.themeColor ||  this.props?.activeThemeColor;
       btnstyle = btnstyle + ' hasActiveFilter';
    }

    if(buttonJSON?.id === 'saveFilter' && !buttonJSON?.disabled){
      themeColor.backgroundColor = buttonJSON?.themeColor;
      buttonJSON.cssStyle= {
        backgroundColor: buttonJSON?.themeColor,
        color: '#fff',
        borderColor: buttonJSON?.themeColor
      }
      // themeColor.color = '#fff';
     
    }

      if(buttonJSON?.id ===  'clearFilterWap'){
        buttonJSON.cssStyle = {
          border: `1px solid  ${buttonJSON?.themeColor}`,
          color: buttonJSON?.themeColor || '#000'
        }
    }

     if(buttonJSON?.id === 'Registradossavebtn' && !buttonJSON?.disabled){
       themeColor.backgroundColor = buttonJSON?.themeColor;
        buttonJSON.cssStyle= {
        backgroundColor: buttonJSON?.themeColor,
        color: '#fff',
        borderColor: buttonJSON?.themeColor
      }
    }

    return (
      <button
        id={buttonJSON.id}
        className={btnstyle}
        type={buttonJSON.type}
        name={buttonJSON.name}
        onClick={buttonJSON.onClickHandler}
        disabled={buttonJSON.disabled}
        autoFocus={buttonJSON.autoFocus}
        aria-label={buttonJSON.ariaLabel}
        aria-hidden={buttonJSON.ariaHidden}
        style={buttonJSON.cssStyle || this.props.cssStyle || this.props.style}
        ref={inputButton => this.button = inputButton}
      >
        {
          buttonJSON.beforeIconClass
            ? <i className={buttonJSON.beforeIconClass} />
            : null
        }
        {
          buttonJSON.beforeImageClass
            ? <img src={buttonJSON.beforeImageClass} />
            : null
        }
        { 
           buttonJSON.addressSvgIcon && <span className='icon-address-svg' dangerouslySetInnerHTML={{ __html: buttonJSON.addressSvgIcon }}/>

        }
        {
          buttonJSON.beforeSvgIcon
            && <span dangerouslySetInnerHTML={{ __html: buttonJSON.beforeSvgIcon }}/>
        }
        { (!!buttonJSON.aditionaIcon && buttonJSON.aditionaIcon) }
        { buttonJSON.value }
        {
          buttonJSON.iconClass
            ? <i className={buttonJSON.iconClass} />
            : null
        }
         {
          buttonJSON.activeCategory
            ? <span style={{width:"20px",height:"20px",backgroundColor:`${this.activeThemeColor}`,borderRadius:'50%',color:"#fff",position:`${!buttonJSON.guestView ? 'relative' : ''}`,left:`${!buttonJSON.guestView ? '10px' : ''}` , ...themeColor}}>{buttonJSON.filteredProducts}</span>
            : null
        }
        {
          buttonJSON.imageClass
            ? <img src={buttonJSON.imageClass} className='sort-arrow' />
            : null
        }
      </button>
    );
  }
}

export default InputButton;
